export const listItems = [
    {
        title: "Mis trabajos",
        list: [{
            path: "/",
            name: "Inicio"
        }, {
            path: "/trabajos",
            name: "Trabajos"
        }]
    },
    {
        title: "Agustín Galluzzo",
        list: [{
            path: "/sobremi",
            name: "Sobre Mí"
        }, {
            path: "/contacto",
            name: "Contacto"
        }]
    }
];
export const copyright = "Copyright © " + (new Date()).getFullYear() + " Agustín Galluzzo.";
export const developBy = "Diseñado y desarrollado por";
export const brand = { text: "ARdevs", href: "/", target: "_blank"};